module.exports = __webpack_public_path__ + "static/media/model-pajero-91-lwb.744c2898.jpg";